import React from "react";
import { useSelector } from "react-redux";
import { useGetAllAdminsQuery } from "../slices/AdminSilce";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Table } from "react-bootstrap";
import Message from "../components/Message";
import Loader from "../components/Loader";

const ViewAdminsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const {
    data: admins,
    isLoading,
    error,
    refetch,
  } = useGetAllAdminsQuery({ token: userInfo?.token });

  return (
    <>
      <Row>
        <h5>All Admins</h5>
        <Col>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error || "Error fetching Admins"}</Message>
          ) : (
            <Table
              striped
              bordered
              hover
              responsive="sm"
              className="table-custom"
            >
              <thead className={`${userInfo.themeColor}ThemeThead`}>
                <tr>
                  <th>Admin Name</th>
                  <th>Role</th>
                  <th>Mobile Number</th>
                </tr>
              </thead>
              <tbody>
                {admins?.map((item) => (
                  <tr key={item._id}>
                    <td>
                      <a
                        onClick={() =>
                          navigate("/adminDetails", {
                            state: {
                              admins,
                              selectedAdminId: item._id,
                            },
                          })
                        }
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        {item.adminName}
                      </a>
                    </td>

                    <td>{item.role}</td>
                    <td>{item.mobileNumber}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ViewAdminsScreen;
